<template>
    <div>
        <h4 class="block-title">Contact Information</h4>
        <div class="row checkout-contact">
            <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.firstName}">
                <label class="form-label">First Name <span class="text-primary">*</span></label>
                <input
                    v-model="firstName"
                    type="text"
                    class="form-control mb-0"
                    placeholder="John">
                <small v-if="validationErrors.firstName">{{ validationErrors.firstName }}</small>
            </div>
            <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.lastName}">
                <label class="form-label">Last Name <span class="text-primary">*</span></label>
                <input
                    v-model="lastName"
                    type="text"
                    class="form-control mb-0"
                    placeholder="Doe">
                <small v-if="validationErrors.lastName">{{ validationErrors.lastName }}</small>
            </div>
            <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.email}">
                <label class="form-label">Email <span class="text-primary">*</span></label>
                <input
                    v-model="email"
                    type="email"
                    class="form-control mb-0"
                    placeholder="johndoe@email.com">
                <small v-if="validationErrors.email">{{ validationErrors.email }}</small>
            </div>
            <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.phone}">
                <label class="form-label">Phone Number</label>
                <input
                    v-model="phone"
                    type="text"
                    class="form-control mb-0"
                    placeholder="123 456 789">
                <small v-if="validationErrors.phone">{{ validationErrors.phone }}</small>
            </div>
            <template v-if="withAddress2">
                <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.address2_firstLine }">
                    <label class="form-label">Address <span class="text-primary">*</span></label>
                    <input
                        v-model="address2.firstLine"
                        type="text"
                        class="form-control mb-0"
                        placeholder="6860 Dallas Pkwy">
                    <small v-if="validationErrors.address2_firstLine">{{ validationErrors.address2_firstLine }}</small>
                </div>
                <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.address2_zipCode }">
                    <label class="form-label">Postal Code <span class="text-primary">*</span></label>
                    <input
                        v-model="address2.zipCode"
                        type="text"
                        class="form-control mb-0"
                        placeholder="75024">
                    <small v-if="validationErrors.address2_zipCode">{{ validationErrors.address2_zipCode }}</small>
                </div>
            </template>
            <template v-if="withAddress">
                <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.address_firstLine }">
                    <label class="form-label">Address <span class="text-primary">*</span></label>
                    <input
                        v-model="address.firstLine"
                        type="text"
                        class="form-control mb-0"
                        placeholder="">
                    <small v-if="validationErrors.address_firstLine">{{ validationErrors.address_firstLine }}</small>
                </div>
                <div class="col-md-6 mb-4">
                    <label class="form-label">Address 2</label>
                    <input
                        v-model="address.secondLine"
                        type="text"
                        class="form-control mb-0"
                        placeholder="">
                </div>
                <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.address_city }">
                    <label class="form-label">City <span class="text-primary">*</span></label>
                    <input
                        v-model="address.city"
                        type="text"
                        class="form-control mb-0"
                        placeholder="">
                    <small v-if="validationErrors.address_city">{{ validationErrors.address_city }}</small>
                </div>
                <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.address_country }">
                    <label class="form-label">Country <span class="text-primary">*</span></label>
                    <input
                        v-model="address.country"
                        type="text"
                        class="form-control mb-0"
                        placeholder="">
                    <small v-if="validationErrors.address_country">{{ validationErrors.address_country }}</small>
                </div>
                <div class="col-md-6 mb-4">
                    <label class="form-label">State</label>
                    <input
                        v-model="address.state"
                        type="text"
                        class="form-control mb-0"
                        placeholder="">
                </div>
                <div class="col-md-6 mb-4" :class="{ 'invalid' : validationErrors.address_zipCode }">
                    <label class="form-label">Postal Code <span class="text-primary">*</span></label>
                    <input
                        v-model="address.zipCode"
                        type="text"
                        class="form-control mb-0"
                        placeholder="">
                    <small v-if="validationErrors.address_zipCode">{{ validationErrors.address_zipCode }}</small>
                </div>

            </template>
        </div>
        <h4 class="block-title">Disclaimer</h4>
        <div class="checkout-disclaimer">
            <div class="form-check"
                 :class="{ 'invalid' : validationErrors.policiesAcceptation }"
                 style="margin-bottom: 12px">
                <input class="form-check-input" type="checkbox" v-model="policiesAcceptation">
                <label class="form-check-label">
                    I have read and understand <a href="https://bikerent.nyc/customer-service" class="text-decoration-underline">Privacy</a> and <a href="#"
                                                                                                                class="text-decoration-underline">Cookies
                    Policy*</a>
                </label>
            </div>
            <p>Tour Central Park Inc., DBA Bike Rent NYC, does not give refunds for customer-cancelled services. No
                bicycle may be rented without signature and liability acceptance of a responsible adult. No cash refunds
                for any reason.</p>
        </div>
        <h4 class="block-title">Payment</h4>


        <div class="checkout-payment">
<!--            <div v-if="isProduct" class="row">-->
<!--                <div class="col-md-6 offset-md-6">-->
<!--                    <Paypal :referrer="referrer" :is-product="isProduct"-->
<!--                            :product-shipping-address="productShippingAddress"-->
<!--                            :product-shipping-method="productShippingMethod"-->
<!--                            :product-variant-selected="productVariantSelected" :product="product"/>-->
<!--                </div>-->
<!--            </div>-->
            <div class="payment-methods">
                <img src="/assets/images/logo/third-party/american-express.png" alt="American Express">
                <img src="/assets/images/logo/third-party/maestro.png" alt="Maestro">
                <img src="/assets/images/logo/third-party/mastercard.png" alt="Mastercard">
                <img src="/assets/images/logo/third-party/visa.png" alt="Visa">
            </div>
            <PaymentCreditCard ref="payment"
                               :referrer="referrer"
                               :is-product="isProduct"
                               :product-shipping-address="productShippingAddress"
                               :product-shipping-method="productShippingMethod"
                               :product-variant-selected="productVariantSelected"
                               :curr-step="currStep"
                               :stripe-submit="stripeSubmit"
                               :disableLoader="disableLoader"
                               :product="product"
            >
                <slot></slot>
            </PaymentCreditCard>
        </div>
    </div>
</template>

<script>
import PaymentCreditCard from "../../forms/PaymentCreditCard";
import Paypal from "./Paypal.vue";
import {mapGetters} from "vuex";
import {DateTime} from "luxon";

export default {
    name: "CheckoutContactInformation",
    components: {Paypal, PaymentCreditCard},
    props: {
        withAddress: {
            type: Boolean,
            default: false
        },
        withAddress2: {
            type: Boolean,
            default: false
        },
        referrer: {
            type: String,
            default: ''
        },
        productShippingAddress: {
            type: String,
            default: ''
        },
        productVariantSelected: {
            type: String,
            default: ''
        },
        productShippingMethod: {
            type: String,
            default: ''
        },
        product: {
            type: Object,
            default: () => {
            }
        },
        isProduct: {
            type: Boolean,
            default: false
        },
        currStep: {
            type: Number,
            default: 0
        },
        stripeSubmit: {
            type: Boolean,
            default: false
        },
        disableLoader: {
            type: Function,
            default: null
        },
    },
    data() {
        return {
            validationErrors: {},
            policiesAcceptation: false
        }
    },
    computed: {
        firstName: {
            get: function () {
                return this.$store.getters['app/firstName'];
            },
            set: function (value) {
                this.$store.commit('app/SET_FIRST_NAME', value);
            }
        },
        lastName: {
            get: function () {
                return this.$store.getters['app/lastName'];
            },
            set: function (value) {
                this.$store.commit('app/SET_LAST_NAME', value);
            }
        },
        email: {
            get: function () {
                return this.$store.getters['app/email'];
            },
            set: function (value) {
                this.$store.commit('app/SET_EMAIL', value);
            }
        },
        phone: {
            get: function () {
                return this.$store.getters['app/phone'];
            },
            set: function (value) {
                this.$store.commit('app/SET_PHONE', value);
            }
        },
        address: {
            get: function () {
                return this.$store.getters['app/address'];
            },
            set: function (value) {
                this.$store.commit('app/SET_ADDRESS', value);
            }
        },
        address2: {
            get: function () {
                return this.$store.getters['app/address2'];
            },
            set: function (value) {
                this.$store.commit('app/SET_ADDRESS2', value);
            }
        }
    },
    methods: {
        validate() {
            this.validationErrors = {};

            if (!this.firstName || !this.firstName.length) {
                this.validationErrors.firstName = 'First Name is required field';
            }

            if (!this.lastName || !this.lastName.length) {
                this.validationErrors.lastName = 'Last name is required field';
            }

            if (!this.email || !this.email.length) {
                this.validationErrors.email = 'Email is required field';
            } else {
                if (!this.email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    // probably, never happens because of browser internal validation
                    this.validationErrors.email = 'Email value is incorrect';
                }
            }

            // if (!this.phone || !this.phone.length) {
            //     this.validationErrors.phone = 'Phone is required field';
            // } else {
            //     if (!this.phone.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)) {
            //         this.validationErrors.phone = 'Phone value is incorrect';
            //     }
            // }

            if (this.withAddress2) {
                if (!this.address2.firstLine || !this.address2.firstLine.length) {
                    this.validationErrors.address2_firstLine = 'Address is required field';
                }

                if (!this.address2.zipCode || !this.address2.zipCode.length) {
                    this.validationErrors.address2_zipCode = 'Postal code is required field';
                }
            }

            if (this.withAddress) {

                if (!this.address.firstLine || !this.address.firstLine.length) {
                    this.validationErrors.address_firstLine = 'Address is required field';
                }

                if (!this.address.city || !this.address.city.length) {
                    this.validationErrors.address_city = 'City is required field';
                }

                if (!this.address.country || !this.address.country.length) {
                    this.validationErrors.address_country = 'Country is required field';
                }

                if (!this.address.zipCode || !this.address.zipCode.length) {
                    this.validationErrors.address_zipCode = 'Postal code is required field';
                }
            }

            if (!this.policiesAcceptation) {
                this.validationErrors.policiesAcceptation = 'You have to read and accept to continue'
            }

            return Object.keys(this.validationErrors).length === 0;
        }
    }
}
</script>

<style scoped>
.invalid, .invalid * {
    color: red !important;
}
</style>
